const heroVideo = document.querySelector('.js-video');
const togglePlayback = document.querySelector('.toggle_playback');
const imgs = togglePlayback?.querySelectorAll('svg');

const isVideoPlaying = video => !!(video?.currentTime > 0 && !video?.paused && !video?.ended && video?.readyState > 2);

function togglePlaybackElements(el) {
  el.forEach(item => item.matches('.sr-only') ? item.classList.remove('sr-only') : item.classList.add('sr-only'))
}

heroVideo?.addEventListener('loadedmetadata', () => {
  heroVideo.currentTime = window.sessionStorage.getItem('savedVideoTimeline')
})

heroVideo?.addEventListener('timeupdate', () => {
  window.sessionStorage.setItem('savedVideoTimeline', heroVideo.currentTime)
})

togglePlayback?.addEventListener('click', function (e) {
  e.preventDefault();
  togglePlaybackElements(imgs);
  isVideoPlaying(heroVideo) ? heroVideo?.pause() : heroVideo?.play();
});
